import React from 'react';
import { Link } from 'react-router-dom';
import "../styles/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-container1">
      <h1 className="policy-containerh">Privacy Policy</h1>
      <p className="last-updated1"><strong>Last Updated:</strong> July 14, 2023</p>
      
      <section>
        <h2 className='policy-containerh2'>1. Introduction</h2>
        <p className='policy-containerp'>Welcome to Makkal Sinthanai Peravai ("we," "our," or "us"). We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website <Link to="/">https://makkalsinthanaiperavai.org/</Link> (the "Site").</p>
      </section>

      <section>
        <h2 className='policy-containerh2'>2. Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul className='policy-containerul'>
          <li className='policy-containerli' ><strong>Personal Information:</strong> Name, email address, phone number, and other contact details when you fill out forms on our Site.</li>
          <li className='policy-containerli'><strong>Usage Data:</strong> Information about how you interact with our Site, including IP address, browser type, pages visited, and time spent on pages.</li>
          <li className='policy-containerli'><strong>Cookies and Tracking Technologies:</strong> We use cookies and similar tracking technologies to enhance your experience on our Site.</li>
        </ul>
      </section>

      <section>
        <h2 className='policy-containerh2'>3. How We Use Your Information</h2>
        <p>We use the collected information for:</p>
        <ul className='policy-containerul'>
          <li className='policy-containerli'>Providing and maintaining our Site</li>
          <li className='policy-containerli'>Notifying you about changes to our Site</li>
          <li className='policy-containerli'>Allowing you to participate in interactive features</li>
          <li className='policy-containerli'>Providing customer support</li>
          <li className='policy-containerli'>Gathering analysis to improve our Site</li>
          <li className='policy-containerli'>Monitoring usage of our Site</li>
          <li className='policy-containerli'>Detecting and preventing technical issues</li>
        </ul>
      </section>

      <section>
        <h2 className='policy-containerh2'>4. Data Security</h2>
        <p>We implement appropriate technical and organizational measures to protect your personal information. However, no internet transmission or electronic storage is 100% secure.</p>
      </section>

      <section>
        <h2 className='policy-containerh2'>5. Third-Party Services</h2>
        <p>Our Site may contain links to third-party websites. We are not responsible for the privacy practices of these external sites.</p>
      </section>

      <section>
        <h2 className='policy-containerh2'>6. Children's Privacy</h2>
        <p>Our Site is not intended for children under 13. We do not knowingly collect personal information from children under 13.</p>
      </section>

      <section>
        <h2 className='policy-containerh2'>7. Changes to This Privacy Policy</h2>
        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
      </section>

      <section>
        <h2 className='policy-containerh2'>8. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:contact@makkalsinthanaiperavai.org">contact@makkalsinthanaiperavai.org</a>.</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;